import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface DashboardUi {
  sidebar: {
    isToggle: boolean
    selectedMenu: string
    selectedSubMenu: string
  }
}

const initialState: DashboardUi = {
  sidebar: {
    isToggle: false,
    selectedMenu: '',
    selectedSubMenu: '',
  },
}

const dashboardUiSlice = createSlice({
  name: 'dashboardUi',
  initialState,
  reducers: {
    toggleSidebar: (state, action: PayloadAction<boolean>) => {
      state.sidebar.isToggle = action.payload
    },
    handleSidebarSelectMenu: (state, action: PayloadAction<string>) => {
      state.sidebar.selectedMenu = action.payload
    },
    handleSidebarSelectSubMenu: (state, action: PayloadAction<string>) => {
      state.sidebar.selectedSubMenu = action.payload
    },
  },
})

export const { toggleSidebar, handleSidebarSelectMenu, handleSidebarSelectSubMenu } =
  dashboardUiSlice.actions

export default dashboardUiSlice.reducer
